import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26c4619a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fs-1 fw-bold",
  style: {"margin-left":"-27px"}
}
const _hoisted_2 = {
  key: 1,
  class: "mb-0 totalResp",
  style: {"margin-left":"-27px"}
}
const _hoisted_3 = { class: "card bg-opacity-0" }
const _hoisted_4 = { class: "row mt-5 mb-5" }
const _hoisted_5 = { class: "col-xs-12 col-sm-8 col-md-8 col-lg-8" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "col-sm-4 col-md-4 col-lg-4 col-xs-12 mb-2"
}
const _hoisted_8 = {
  class: "svg-icon svg-icon-1 position-absolute ms-6",
  style: {"top":"30px"}
}
const _hoisted_9 = { class: "col-sm-3 col-md-3 col-lg-3 col-xs-12 mb-2" }
const _hoisted_10 = {
  key: 1,
  class: "col-sm-3 col-md-3 col-lg-3 col-xs-12 mb-2"
}
const _hoisted_11 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4 text-end" }
const _hoisted_12 = {
  key: 0,
  class: "row px-10"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "alert alert-dismissible bg-light-primary d-flex flex-sm-row p-5 mb-3 text-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column pe-0 pe-sm-10" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "No se encontraron registros")
    ])
  ])
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "card-body p-0" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "symbol symbol-circle symbol-30px overflow-hidden me-3" }
const _hoisted_19 = { class: "symbol-label text-uppercase fs-sm bg-gray-lighten" }
const _hoisted_20 = { class: "trashAndEdit" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "row"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Sin resultados")
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "row align-items-center top-less-6 py-3 px-3 m-0 border border-top-0 border-gray-600 rounded-bottom bg-gray"
}
const _hoisted_27 = { class: "col-sm-12 col-md-6 mb-3 mb-md-0 d-flex flex-row align-items-center fs-sm" }
const _hoisted_28 = { class: "me-2" }
const _hoisted_29 = { class: "col-sm-12 col-md-6 text-end" }
const _hoisted_30 = {
  id: "kt_referre_dusers_tab_content_pagination",
  class: "tab-content"
}
const _hoisted_31 = { class: "pagination justify-content-end fs-xs" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "page-link"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_KTDatatable = _resolveComponent("KTDatatable")!
  const _component_ModalNewUser = _resolveComponent("ModalNewUser")!
  const _component_ModalDeleteUser = _resolveComponent("ModalDeleteUser")!
  const _component_DrawerUserDetail = _resolveComponent("DrawerUserDetail")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.path == '/users' ? 'container-xxl negative-top' : 'container-xxl'])
    }, [
      (!_ctx.sub)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(_ctx.path == '/users' ? 'Usuarios' : 'Usuarios asignados'), 1))
        : _createCommentVNode("", true),
      (_ctx.path == '/users')
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.total) + " " + _toDisplayString(_ctx.total == 1 ? " Registro" : " Registros"), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (!(_ctx.userRole?.id === 2))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "data-kt-subscription-table-filter": "search",
                    class: "form-control fs-base form-control-solid ps-14 bg-main border border-gray-600 userSearch",
                    placeholder: "Buscar usuario",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchWord) = $event)),
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems()))
                  }, null, 544), [
                    [_vModelText, _ctx.searchWord]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              (!_ctx.sub)
                ? (_openBlock(), _createBlock(_component_Field, {
                    key: 0,
                    name: "Rol",
                    autocomplete: "off",
                    class: "form-select form-select-solid select2-hidden-accessible",
                    modelValue: _ctx.searchIdRole,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchIdRole) = $event))
                  }, {
                    default: _withCtx(({ value, errorMessage, handleChange }) => [
                      _createVNode(_component_el_select, {
                        class: "w-100",
                        name: "Rol",
                        value: value,
                        "model-value": value,
                        "onUpdate:modelValue": handleChange,
                        loading: _ctx.loading,
                        size: "large",
                        onChange: _ctx.searchByRole
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            value: "Rol",
                            selected: true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Rol")
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.name_rol,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            (!(_ctx.userRole?.id === 2))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (!_ctx.sub)
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: 0,
                        name: "Agencia",
                        autocomplete: "off",
                        class: "form-select form-select-solid select2-hidden-accessible",
                        modelValue: _ctx.searchIdAgency,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchIdAgency) = $event))
                      }, {
                        default: _withCtx(({ value, errorMessage, handleChange }) => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            name: "Agencia",
                            value: value,
                            "model-value": value,
                            "onUpdate:modelValue": handleChange,
                            loading: _ctx.loading,
                            size: "large",
                            onChange: _ctx.searchByAgency
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                value: "Agencia",
                                selected: true
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Agencia")
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agencies, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("button", {
            class: "btn btn-primary btn-lg fs-base",
            "data-bs-toggle": "modal",
            "data-bs-target": "#newUserModal",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cleanUserToEdit()))
          }, " Crear usuario ", 512), [
            [_vShow, _ctx.$can('Crear usuario')]
          ])
        ])
      ]),
      (!_ctx.areUsers)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_KTDatatable, {
          "table-data": _ctx.dataUsers,
          "table-loading": _ctx.loading,
          "table-header": _ctx.headerConfig,
          "enable-items-per-page-dropdown": false,
          "rows-per-page": _ctx.showing
        }, {
          "cell-nombre": _withCtx(({ row: customer }) => [
            _createElementVNode("div", {
              class: "text-gray-800 text-hover-primary mb-1 cursor-pointer",
              "data-kt-drawer-toggle": "true",
              "data-kt-drawer-target": "#kt_drawer_user",
              onClick: ($event: any) => (
              _ctx.$can('Ver detalle de usuario') ? _ctx.openDrawer(customer) : _ctx.dontOpen()
            )
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(customer.name.charAt(0) + customer.last_name.charAt(0)), 1)
                ]),
                _createTextVNode(" " + _toDisplayString(customer.name) + " " + _toDisplayString(customer.last_name), 1)
              ])
            ], 8, _hoisted_16)
          ]),
          "cell-correo": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, _toDisplayString(customer.email), 1)
          ]),
          "cell-rol": _withCtx(({ row: customer }) => [
            _createTextVNode(_toDisplayString(customer.role), 1)
          ]),
          "cell-agencia": _withCtx(({ row: customer }) => [
            _createTextVNode(_toDisplayString(customer.name_agency), 1)
          ]),
          "cell-createdAt": _withCtx(({ row: customer }) => [
            _createTextVNode(_toDisplayString(customer.createdAt), 1)
          ]),
          "cell-actions": _withCtx(({ row: customer }) => [
            _createElementVNode("div", _hoisted_20, [
              (_ctx.$can('Editar usuario'))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "btn btn-sm btn-icon btn-active-icon-primary",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#newUserModal",
                    onClick: ($event: any) => (_ctx.editUser(customer))
                  }, [
                    _createVNode(_component_inline_svg, { src: "media/icons/iconsax/edit-2.svg" })
                  ], 8, _hoisted_21))
                : _createCommentVNode("", true),
              (_ctx.$can('Eliminar usuario'))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "btn btn-sm btn-icon btn-active-icon-primary",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#confirmUserDelete",
                    onClick: ($event: any) => (_ctx.deleteUser(customer))
                  }, [
                    _createVNode(_component_inline_svg, { src: "media/icons/iconsax/trash.svg" })
                  ], 8, _hoisted_22))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["table-data", "table-loading", "table-header", "rows-per-page"]),
        (_ctx.noResults)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
          : _createCommentVNode("", true),
        (!_ctx.noResults)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _withDirectives(_createElementVNode("span", _hoisted_28, "Elementos por página:", 512), [
                  [_vShow, _ctx.links.length > 0]
                ]),
                _withDirectives(_createVNode(_component_Field, {
                  name: "pages",
                  autocomplete: "off",
                  class: "form-select form-select-solid select2-hidden-accessible w-75p pageNumber",
                  modelValue: _ctx.showing,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showing) = $event))
                }, {
                  default: _withCtx(({ value, errorMessage, handleChange }) => [
                    _createVNode(_component_el_select, {
                      name: "pages",
                      value: value,
                      "model-value": value,
                      "onUpdate:modelValue": handleChange,
                      loading: _ctx.loading,
                      class: _normalizeClass([_ctx.pageNumber, "w-75px"]),
                      onChange: _ctx.showingSet
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs-_ctx.sm),
                          value: 10,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("10")
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs-_ctx.sm),
                          value: 25,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("25")
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs-_ctx.sm),
                          value: 50,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("50")
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs-_ctx.sm),
                          value: 100,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("100")
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 2
                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "class", "onChange"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]), [
                  [_vShow, _ctx.links.length > 0]
                ]),
                _withDirectives(_createElementVNode("span", { class: "w-25 fs-sm" }, " " + _toDisplayString(_ctx.from) + " - " + _toDisplayString(_ctx.to) + " de " + _toDisplayString(_ctx.total), 513), [
                  [_vShow, _ctx.links.length > 0]
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _withDirectives(_createElementVNode("div", _hoisted_30, [
                  _createElementVNode("ul", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (lin, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: _normalizeClass([
                  lin ? 'page-item' : '',
                  lin.active ? 'active' : '',
                  lin.url == null ? 'disabled' : '',
                ]),
                        onClick: ($event: any) => (_ctx.getPagination(lin))
                      }, [
                        (lin.url != null)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_33, _toDisplayString(lin.label.includes("Anterior")
                      ? "<"
                      : lin.label.includes("Siguiente")
                      ? ">"
                      : lin.label), 1))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_32))
                    }), 128))
                  ])
                ], 512), [
                  [_vShow, _ctx.links.length > 0]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ModalNewUser, {
      onSendData: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getUserData($event))),
      onSendEditData: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getUserIdEdit($event))),
      userToEdit: _ctx.userToEdit,
      type: _ctx.createNewUser,
      idAgency: _ctx.idAgency,
      nameAgency: _ctx.nameAgency
    }, null, 8, ["userToEdit", "type", "idAgency", "nameAgency"]),
    _createVNode(_component_ModalDeleteUser, {
      onDelData: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getUserIdDel($event))),
      id: _ctx.idToDelete,
      nombre: _ctx.userToDelete
    }, null, 8, ["id", "nombre"]),
    _createVNode(_component_DrawerUserDetail, {
      onDeleteUser: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteUser($event))),
      onEditUser: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editUser($event))),
      id: _ctx.idUser
    }, null, 8, ["id"])
  ], 64))
}